export default "__VITE_ASSET__DMjPmsHT__"